// Deterministic golden-spiral mapping (mirrors backend)
const GOLDEN = (Math.sqrt(5) - 1) / 2;
export const TOTAL = 14200;
export const TOP_NUMBER_BASE = 14188;

export function coordsForToken(n) {
    const t = (n - 1) / Math.max(TOTAL - 1, 1);
    const radius = Math.sqrt(t) * 30.0; // degrees from south pole
    const angle = (n * GOLDEN * 2 * Math.PI) % (2 * Math.PI);
    const lat = -90 + radius;
    let lon = ((angle * 180) / Math.PI + 180) % 360;
    lon = lon > 180 ? lon - 360 : lon;
    return { lat: +lat.toFixed(4), lon: +lon.toFixed(4) };
}

// Map (lat, lon) — for Antarctica polar disk — to xy on a square canvas of size S.
// lat range: -90 (center) to -60 (edge)
export function projectPolar(lat, lon, size) {
    const r = ((lat + 90) / 30) * (size / 2); // 0..size/2
    const theta = (lon * Math.PI) / 180;
    const cx = size / 2;
    const cy = size / 2;
    const x = cx + r * Math.sin(theta);
    const y = cy - r * Math.cos(theta);
    return { x, y };
}

export function formatCoords(lat, lon) {
    const latLabel = `${Math.abs(lat).toFixed(2)}°${lat < 0 ? "S" : "N"}`;
    const lonLabel = `${Math.abs(lon).toFixed(2)}°${lon < 0 ? "W" : "E"}`;
    return `${latLabel} ${lonLabel}`;
}
